export function LogoVodoluxLg(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox='0 0 523.14 152.76' {...props}>
      <defs>
        <style>{'.cls-1 {fill: #d7282c;}.cls-2 {fill: #339AF0;}'}</style>
      </defs>
      <title>{'vodolux logo'}</title>
      <path
        className='cls-1'
        d='M1722.48,1015.1h0l77.36,141.28h.64a18.43,18.43,0,0,0,16.21-27.21l-61.79-114.08A18.43,18.43,0,0,0,1722.48,1015.1Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-2'
        d='M1692.9,1128.41l32.39-59.8-16-29.19-48.62,89.75a18.43,18.43,0,0,0,16.21,27.21h96.45l-15.31-28Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-2'
        d='M1826.41,1003.62H1854q10.37,0,16.1,4t5.72,12q0,10.54-9.55,13.79a18.16,18.16,0,0,1,8.65,5.37q3.42,3.83,3.43,10.32a16.33,16.33,0,0,1-2.26,8.79,14,14,0,0,1-6.08,5.46,34.47,34.47,0,0,1-7.85,2.61,43.42,43.42,0,0,1-8.61.81h-27.14Zm38.41,44q0-8.11-10.73-8.12h-14.24v16.23h13.52a17.32,17.32,0,0,0,8.39-1.71C1863.8,1052.88,1864.82,1050.74,1864.82,1047.62Zm-2.43-25.7q0-7.21-9.56-7.21h-12.89v14.43h13.61a10.3,10.3,0,0,0,6.4-1.85A6.31,6.31,0,0,0,1862.39,1021.92Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-2'
        d='M1889.16,1062q-6.95-6-6.94-16.86t6.94-16.86a26.87,26.87,0,0,1,33.95,0q6.9,6,6.9,16.86t-6.9,16.86a26.84,26.84,0,0,1-33.95,0Zm25.16-8.43a13.41,13.41,0,0,0,0-16.86,10.51,10.51,0,0,0-8.2-3.29,10.4,10.4,0,0,0-8.17,3.29,13.59,13.59,0,0,0,0,16.86,10.37,10.37,0,0,0,8.17,3.3A10.48,10.48,0,0,0,1914.32,1053.52Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-2'
        d='M1942.91,1078.18h-11.55v-21h6q6.76-11.72,6.32-33.72h35.61v33.72h6.49v21h-11.54v-11.45h-31.37Zm12.35-45.17q-.54,14.79-4.87,24.16h16.5V1033Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-2'
        d='M1994.84,1062q-6.94-6-6.94-16.86t6.94-16.86a26.86,26.86,0,0,1,33.94,0q6.92,6,6.9,16.86t-6.9,16.86a26.83,26.83,0,0,1-33.94,0Zm25.15-8.43a13.41,13.41,0,0,0,0-16.86,10.49,10.49,0,0,0-8.2-3.29,10.36,10.36,0,0,0-8.16,3.29,13.59,13.59,0,0,0,0,16.86,10.34,10.34,0,0,0,8.16,3.3A10.47,10.47,0,0,0,2020,1053.52Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-2'
        d='M2060,1033.37q-.54,7.94-1.49,13.66a57.67,57.67,0,0,1-2.75,10.64,16.81,16.81,0,0,1-4.87,7.44,11.25,11.25,0,0,1-7.39,2.53,20.21,20.21,0,0,1-6.85-1.27v-9.91a7,7,0,0,0,2.61.54q4.7,0,6.58-8.39t2.62-25.16h35.16v43.28h-12.53v-33.36Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-2'
        d='M2089.6,1045.09a24.78,24.78,0,0,1,2.08-10.41,18.6,18.6,0,0,1,5.45-7.17,26.46,26.46,0,0,1,7.12-4,22.34,22.34,0,0,1,7.62-1.35,24.19,24.19,0,0,1,11.23,2.44,16.72,16.72,0,0,1,7,6.26,25.89,25.89,0,0,1,3.11,8.66,21.23,21.23,0,0,1-.5,9.6h-30.47a9.59,9.59,0,0,0,5.23,6.72,21.38,21.38,0,0,0,10,2.21,32.07,32.07,0,0,0,13.08-2.62v9.83q-6.4,2.7-15.87,2.71-10.82,0-17.94-6T2089.6,1045.09Zm31.83-4a8.47,8.47,0,0,0-1.71-6.13c-1.45-2.11-3.91-3.16-7.4-3.16a10.78,10.78,0,0,0-7.12,2.48,8.61,8.61,0,0,0-3.06,6.81Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-2'
        d='M2149.83,1066.73h-10.91v-43.28h12.53v24.35l19.3-24.35h10.82v43.28h-12.44v-24.34Zm24.26-52.11a28.23,28.23,0,0,1-27.59,0v-9.38a29.46,29.46,0,0,0,27.59,0Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-1'
        d='M1974.81,1092h43.24v63.07h-13.51v-50.9h-17.3q-.54,6.84-1,11.39t-1.35,10.5a93,93,0,0,1-1.94,9.82,67.53,67.53,0,0,1-2.7,8,22.44,22.44,0,0,1-3.78,6.49,18,18,0,0,1-5.1,4,14,14,0,0,1-6.66,1.58,20.58,20.58,0,0,1-7-1.17v-11.89a13.86,13.86,0,0,0,4.32.45,5.84,5.84,0,0,0,3.16-1.13,9,9,0,0,0,2.57-3.15,39.23,39.23,0,0,0,2-4.33,31.55,31.55,0,0,0,1.48-5.85c.42-2.43.78-4.6,1.09-6.49s.58-4.37.85-7.43.48-5.56.63-7.48.33-4.56.54-7.93S1974.69,1093.65,1974.81,1092Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-1'
        d='M2088.05,1116.62q6.94,6,6.94,16.85t-6.94,16.84a24.86,24.86,0,0,1-16.93,6,24.46,24.46,0,0,1-14.78-4.73,20.42,20.42,0,0,1-8.11-13.2h-7.84v16.67h-12.52v-43.25h12.52v16.67h7.84a20.46,20.46,0,0,1,8.11-13.2,24.46,24.46,0,0,1,14.78-4.73A24.91,24.91,0,0,1,2088.05,1116.62Zm-25.13,8.06a14.8,14.8,0,0,0,0,17.57q2.88,3.46,8.2,3.47t8.28-3.47a14.8,14.8,0,0,0,0-17.57q-2.88-3.47-8.28-3.47T2062.92,1124.68Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-1'
        d='M2113.46,1155.09h-12.52v-43.25h12.52V1128h5.23l11-16.13h14.05l-14.86,21.36,16.12,21.89h-14L2118.5,1138h-5Z'
        transform='translate(-1658.43 -1003.62)'
      />
      <path
        className='cls-1'
        d='M2143.37,1134.1a25.54,25.54,0,0,1,2.12-10.63,19.35,19.35,0,0,1,5.63-7.44,25.31,25.31,0,0,1,7.75-4.14,28.28,28.28,0,0,1,8.92-1.4,27.69,27.69,0,0,1,13.33,3.16v11a20.88,20.88,0,0,0-11.53-3.25,15.16,15.16,0,0,0-9.55,3q-3.87,3-3.88,9.1,0,5.85,3.88,9a14.5,14.5,0,0,0,9.37,3.11,23.09,23.09,0,0,0,12.16-3.15v11.08a36.81,36.81,0,0,1-14.59,2.88,25.37,25.37,0,0,1-16.67-5.72Q2143.36,1144.92,2143.37,1134.1Z'
        transform='translate(-1658.43 -1003.62)'
      />
    </svg>
  );
}
